<template>
    <div class="index">
        <div class="top_info">
            <div class="row">
                <div class="top">
                    <i class="fas fa-user-tie"></i>
                    留言數
                </div>
                <div class="num">{{ total }}</div>
            </div>
        </div>
        <div class="table">
            <div class="title">
                <i class="far fa-calendar-check"></i>
                留言管理
            </div>
            <div class="top_bar">
                <div class="search">
                    <div class="search_bar">
                        <el-input placeholder="請輸入關鍵字" prefix-icon="el-icon-search" v-model="keyword"></el-input>
                    </div>
                    <div class="search_page">
                        <el-input v-model="pageNum" placeholder="頁數" prefix-icon="el-icon-info"></el-input>
                    </div>
                    <div class="search_btn">
                        <el-button @click="search()" type="primary">搜尋</el-button>
                    </div>
                    <div class="search_btn">
                        <el-button @click="reset()" type="info">重設</el-button>
                    </div>
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>編號</th>
                        <th>姓名</th>
                        <th>電話</th>
                        <th>信箱</th>
                        <th>公司</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody v-loading="loading">
                    <tr v-for="(item, idx) in list" :key="item.id">
                        <td @click="openDetail(item)">{{ total - (page - 1) * quantity - idx }}</td>
                        <td class="blue" @click="openDetail(item)">{{ item.name }}</td>
                        <td>{{ item.phone }}</td>
                        <td>{{ item.email }}</td>
                        <td>{{ item.company }}</td>
                        <td class="edit">
                            <el-button @click.native="del(item.id)" circle icon="el-icon-delete" type="danger"></el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="page" v-if="total">
                <el-pagination @current-change="pageChange" :current-page="page" :page-size="parseInt(quantity)" :total="total" background layout="prev, pager, next"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { getContact, delContact } from '@/api'
export default {
    data() {
        return {
            loading: false,
            list: '',
            total: 0,
            searchText: '',
            page: 1,
            quantity: 20,
            category: '',
            keyword: '',
            pageNum: 20
        }
    },
    created() {
        this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
        this.pageNum = this.$route.query.quantity ? parseInt(this.$route.query.quantity) : 20
        this.keyword = this.$route.query.keyword ? this.$route.query.keyword : ''
        this.quantity = this.pageNum
        this.loadProductList()
    },
    methods: {
        search() {
            this.page = 1
            this.quantity = this.pageNum
            this.$router.replace({ query: { quantity: this.quantity, page: this.page, keyword: this.keyword } })
            this.loadProductList()
        },
        reset() {
            this.$router.replace({ query: {} })
            this.page = 1
            this.quantity = 20
            this.pageNum = 20
            this.keyword = ''
            this.loadProductList()
        },
        pageChange(value) {
            this.page = value
            this.$router.replace({ query: { page: this.page, quantity: this.quantity, keyword: this.keyword } })
            this.loadProductList()
        },
        loadProductList() {
            this.loading = true
            getContact({
                page: this.page,
                quantity: this.quantity,
                keyword: this.keyword
            }).then(res => {
                this.total = res.data.total
                this.list = res.data.data_list
                this.loading = false
            })
        },
        del(id) {
            let pass = confirm('是否刪除此留言？')
            if (pass) {
                delContact({ id: id }).then(() => {
                    this.$message.success('刪除成功')
                    this.loadProductList()
                })
            } else {
                this.$message.info('取消')
            }
        },
        openDetail(data) {
            this.$alert(
                `
                  <div class="pop_detail">
                    <div class="row_all">
                      <div class="row">
                        <div class="left">編號</div>
                        <div class="right">${data.id}</div>
                      </div>
                      <div class="row">
                        <div class="left">姓名</div>
                        <div class="right">${data.name}</div>
                      </div>
                      <div class="row">
                        <div class="left">電話</div>
                        <div class="right">${data.phone}</div>
                      </div>
                      <div class="row">
                        <div class="left">信箱</div>
                        <div class="right">${data.email}</div>
                      </div>
                      <div class="row">
                        <div class="left">公司</div>
                        <div class="right">${data.company}</div>
                      </div>
                      <div class="row">
                        <div class="left">訊息</div>
                        <div class="right">${data.message}</div>
                      </div>
                      <div class="row">
                        <div class="left">留言時間</div>
                        <div class="right">${data.public_date}</div>
                      </div>
                    </div>
                  </div>
                `,
                '[ ' + data.title + ' ]',
                {
                    dangerouslyUseHTMLString: true,
                    closeOnClickModal: true,
                    showConfirmButton: false
                }
            )
        }
    }
}
</script>
<style lang="scss" scoped>
.table {
    padding: 70px 0;
    background: $color-white;
    border-radius: $radius;
    box-shadow: 4px 4px 40px $color-shadow;
    border: 1px solid $color-table;
    position: relative;
}
table {
    width: 100%;
    border: 1px solid $color-table;
    border-left: none;
    border-right: none;
    background: $color-white;
    line-height: 30px;
    border-collapse: collapse;
    color: $color-black-2;
    font-family: $font-2;
    font-size: $font-size-5;
    text-align: center;
}
td,
th {
    padding: 5px;
    border-bottom: 1px solid $color-table;
}
tbody tr:nth-of-type(odd) {
    background: #def4ff;
}
tbody tr:hover {
    background: #f3f3f3;
}
.page {
    position: absolute;
    right: 0;
    bottom: 20px;
}
tr:nth-child(1) {
    border-bottom: 1px solid #666;
}
.edit {
    width: 120px;
    text-align: center;
    i {
        width: 30px;
        text-align: center;
    }
}
th {
    font-weight: bold;
    font-family: $font-3;
    letter-spacing: 2px;
}
.top_bar {
    display: flex;
    position: absolute;
    top: 15px;
    right: 0px;
}
.slot {
    width: 150px;
    padding-right: 20px;
}
.search {
    width: 460px;
    display: flex;
    padding-left: 20px;
}
.search_bar {
    width: 200px;
    margin-right: 20px;
}
.search_page {
    width: 120px;
    margin-right: 20px;
}
.search_btn {
    width: 50px;
    margin-right: 40px;
}
.title {
    position: absolute;
    top: 15px;
    left: 20px;
    line-height: 40px;
    font-size: $font-size-2;
    font-family: $font-3;
    color: $color-black-2;
    letter-spacing: 2px;
}
.tag {
    color: $color-white;
    font-size: $font-size-6;
    width: 80px;
    font-family: $font-3;
    font-weight: bold;
    border-radius: $radius;
    letter-spacing: 1px;
    margin: auto;
}
.tag-success {
    background: $color-green;
}
.tag-none {
    background: $color-black-3;
}
.tag-error {
    background: $color-red;
}
.tag-ing {
    background: $color-orange;
}
li {
    width: 100%;
    margin: 0;
}
ul {
    height: 30px;
}
.bold {
    font-weight: bold;
    font-family: $font-2;
}
.text_left {
    text-align: left;
}
.text_right {
    text-align: right;
}
.color_green {
    color: $color-green;
}
.date {
    color: #999;
}
.id {
    cursor: pointer;
    text-decoration: underline;
}
img {
    height: 100px;
}
.img_cover {
    padding: 0;
    padding-top: 10px;
}
.row_right {
    margin-right: 10px;
}
.blue {
    color: #4ba5ff;
    cursor: pointer;
}
.image {
    padding-top: 15px;
}
</style>
